<template>
  <div>
    <new-maintainInfo showingPage="maintainInfo"></new-maintainInfo>
  </div>
</template>

<script>
import backgroundSupply from '../../../components/backgroundSupply.vue' 
/**
 *@ClassName:repoInfoBGS
 *@Description:报事信息-后台补单
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-04-21
 */
export default {
  components: {
    'new-maintainInfo': backgroundSupply 
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
  
},
}
</script>
<style lang='scss'>
 
</style>
